import Box from "@mui/material/Box";
import RemoveButton from "./RemoveButton";

export const getColumns = (t) => {
	return [
		{ label: t("ordinal_number_short"), name: "lp" },
		{ label: t("company_name_label"), name: "name" },
		{ label: t("nip_label"), name: "nip" },
		{ label: t("email_label"), name: "email" },
		{
			label: t("actions"),
			name: "id",
			options: {
				filter: false,
				sort: false,
				empty: true,
				customBodyRender: (value, tableMeta, updateValue) => {
					return (
						<Box sx={{ display: "flex", gap: "6px", justifyContent: "center" }}>
							<RemoveButton recipientId={value} />
						</Box>
					);
				},
			},
		},
	];
};

export const getOptions = (t) => {
	return {
		searchOpen: true,
		search: false,
		searchAlwaysOpen: true,
		searchPlaceholder: t("search"),
		filter: false,
		download: true,
		viewColumns: false,
		selectableRows: "none",
		print: false,
		rowsPerPageOptions: [10, 20, 50, 100],
		rowsPerPage: 20,
		textLabels: {
			pagination: {
				next: t("next_page"),
				previous: t("previous_page"),
				rowsPerPage: t("rows_per_page"),
				displayRows: t("of"),
			},
			toolbar: {
				search: t("search"),
				downloadCsv: t("download_csv"),
				print: t("print"),
				viewColumns: t("select_columns"),
				filterTable: t("filters"),
			},
			filter: {
				title: t("filters"),
				reset: t("reset"),
				all: t("all"),
			},
			viewColumns: {
				title: t("show_columns"),
			},
			selectedRows: {
				text: t("removed_rows"),
				delete: t("remove"),
			},
			body: {
				noMatch: t("no_matching_data_found"),
			},
		},
	};
};
